export enum enumBillItemProductCode {
  ISF = 'ISF',
  SELF_ENTRY = 'SEE',
  BROKER_ENTRY = 'BRE',
  ADDITIONAL_LINES = 'ALA',
  ES_DUTIES = 'DAF',
  ISF_SINGLE_BOND = 'SIB',
  ES_SINGLE_BOND = 'SEB',
  ADDITION_TO_ENTRY_BOND = 'AEB',
  ADDITIONAL_INVOICES = 'AIA',
  COLLECTION_FEE = 'COF',
  CONTINUOUS_ANNUAL_BOND = 'CAB',
  FWS = 'FWS',
  OTHER_PGA = 'PGA',
  OTHER_ADDITIONAL_PAYMENT = 'OAP',
  SALES_TAX = 'SST',
  ADDITIONAL_CUSTOMS_DUTIES = 'ACD',
  ADDITIONAL_ENTRY_HANDLING = 'AEH',
  DISCOUNT = 'DSC',
  ORIGIN_CBM = 'OCBM',
  ORIGIN_HBL = 'OHBL',
  FREIGHT = 'FRGT',
  DESTINATION_CBM = 'DCBM',
  DESTINATION_HBL = 'DHBL',
  EXPORT_LICENSE = 'EXL',
  LOADING_FEES = 'OWGT',
  UNLOADING_FEES = 'DWGT',
  ADDITIONAL_CHARGES = 'ADDC',
  STORAGE = 'STRG',
  LATE_BROKER_ENTRY = 'LBE',
  TRUCKER_BROKER_ENTRY = 'TBRE',
  /** @deprecated Retained only to render historical bills from when the deposit feature was active. */
  TRUCKER_DEPOSIT = 'DEP',
  POA = 'POA',
  /** @deprecated Retained only to render historical bills from when the deposit feature was active. */
  DEPOSIT_SETTLEMENT = 'DEPS',
  /** @deprecated Retained only to render historical bills from when the deposit feature was active. */
  DEPOSIT_DIFFERENCE = 'DEPD',
  STARTERPLN = 'STARTERPLN',
  GROWTHPLN = 'GROWTHPLN',
  ENTERPRISEPLN = 'ENTERPRISEPLN',
  MARINE_INSURANCE = 'MIS',
  MARINE_INSURANCE_PROCESSING = 'MIP',
  MARINE_INSURANCE_DIFFERENCE = 'MISD',
  MARINE_INSURANCE_PROCESSING_DIFFERENCE = 'MIPD',
  ASSIGNED_CBP_NUMBER_REQUEST = 'CAIN',
  ASSIGNED_CBP_NUMBER_REQUEST_1 = 'CAIN1',
  ASSIGNED_CBP_NUMBER_REQUEST_2 = 'CAIN2',
}
